import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GameObject, Movement2dComponent, Transform2dComponent} from '@specials/gcs-engine';

import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

import {SpaceshipAnimationComponent} from './components/SpaceshipAnimationComponent';
import {SpaceshipAnimationManagerComponent} from './components/SpaceshipAnimationManagerComponent';
import {SpaceshipDataComponent} from './components/SpaceshipDataComponent';
import {SpaceshipInteractivityComponent} from './components/SpaceshipInteractivityComponent';
import {SpaceshipMessageComponent} from './components/SpaceshipMessageComponent';
import {SpaceshipViewComponent} from './components/SpaceshipViewComponent';

export class Spaceship extends GameObject {
  constructor(
    public readonly transformComponent: Transform2dComponent,
    public readonly movementComponent: Movement2dComponent,
    public readonly viewComponent: SpaceshipViewComponent,
    public readonly animationComponent: SpaceshipAnimationComponent,
    public readonly interactivityComponent: SpaceshipInteractivityComponent,
    public readonly spaceshipMessageComponent: SpaceshipMessageComponent,
    private readonly animationManager: SpaceshipAnimationManagerComponent,
    private readonly dataComponent: SpaceshipDataComponent,
    private readonly rendererComponent: PixiViewRendererComponent,
  ) {
    super();

    this.addComponent(
      this.dataComponent,
      this.transformComponent,
      this.movementComponent,
      this.viewComponent,
      this.animationComponent,
      this.animationManager,
      this.interactivityComponent,
      this.spaceshipMessageComponent,
      this.rendererComponent,
    );
  }
}

injected(
  Spaceship,
  DI_TOKENS.transform2dComponent,
  DI_TOKENS.movement2dComponent,
  DI_TOKENS.clickerGameSpaceshipViewComponent,
  DI_TOKENS.clickerGameSpaceshipAnimationComponent,
  DI_TOKENS.clickerGameSpaceshipInteractivityComponent,
  DI_TOKENS.clickerSpaceshipMessageComponent,
  DI_TOKENS.clickerGameSpaceshipAnimationManagerComponent,
  DI_TOKENS.clickerGameSpaceshipDataComponent,
  DI_TOKENS.pixiViewRendererComponent,
);
